import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    // Check for institution specific token or ID if needed, but usually 'token' is the main auth key.
    // The user prompt mentioned "institution and candidate cannot go to profile unless they are authorized",
    // so checking for the presence of a token is the standard way.

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
